import React from 'react';
import { Bell, Search, Menu, LogOut } from 'lucide-react';
import { Input } from './ui/Input';
interface HeaderProps {
  title: string;
  onMenuClick: () => void;
  onLogout: () => void;
}
export function Header({
  title,
  onMenuClick,
  onLogout
}: HeaderProps) {
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 md:px-6 sticky top-0 z-40" data-id="element-198">
      <div className="flex items-center gap-4" data-id="element-199">
        <button onClick={onMenuClick} className="p-2 -ml-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg lg:hidden transition-colors" aria-label="Menü öffnen" data-id="element-200">
          <Menu className="h-6 w-6" data-id="element-201" />
        </button>
        <h1 className="text-xl font-bold text-slate-900 truncate" data-id="element-202">{title}</h1>
      </div>

      <div className="flex items-center gap-4 md:gap-6" data-id="element-203">
        <div className="w-64 hidden md:block" data-id="element-204">
          <Input placeholder="Suchen..." icon={<Search className="h-4 w-4" data-id="element-206" />} className="bg-slate-50 border-slate-200" data-id="element-205" />
        </div>

        <button className="relative p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors" data-id="element-207">
          <Bell className="h-5 w-5" data-id="element-208" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full ring-2 ring-white" data-id="element-209"></span>
        </button>

        <button onClick={onLogout} className="p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors" title="Abmelden" aria-label="Abmelden" data-id="element-210">
          <LogOut className="h-5 w-5" data-id="element-211" />
        </button>
      </div>
    </header>;
}